import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  RetrieveZonesIndicatorsFilter,
  Identifiable,
  Sort,
  ZoneIndicators,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  zones: Identifiable<ZoneIndicators>[];
  canRetrieveNextZonesIndicators: boolean;
  index: number;
  retrieveZonesIndicators(
    request: Boundaries["retrieveZonesIndicators"]["request"],
  ): void;
}

function useRetrieveZonesIndicators(
  filter: RetrieveZonesIndicatorsFilter,
  sort: Sort,
  size: number,
  view: "simple" | "indicators" = "simple",
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveZonesIndicatorsRequestPending(
        filter,
        sort,
        size,
        view,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveZonesIndicatorsRequestSuccess(
        filter,
        sort,
        size,
        view,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveZonesIndicatorsRequestFailure(
        filter,
        sort,
        size,
        view,
      ),
    ),
    zones: useSelector(() =>
      selector.getZonesIndicators(filter, sort, size, view),
    ),
    canRetrieveNextZonesIndicators: useSelector(() =>
      selector.canRetrieveZonesIndicators(filter, sort, size, view),
    ),
    index: useSelector(() =>
      selector.getRetrieveZonesIndicatorsIndex(filter, sort, size, view),
    ),
    retrieveZonesIndicators: core.retrieveZonesIndicators,
  };
}

export { useRetrieveZonesIndicators };
